<div class="archive-posts_events">
  <sng-posts_events-list-scroll *ngIf="access" [type]="'all'" [access]="access"></sng-posts_events-list-scroll>
</div>